import { render } from "./buy-sell.vue?vue&type=template&id=645bc976"
import script from "./buy-sell.vue?vue&type=script&lang=js"
export * from "./buy-sell.vue?vue&type=script&lang=js"

import "./buy-sell.vue?vue&type=style&index=0&id=645bc976&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__